export enum LogTypes {
    Authorize,
    BootNotification,
    ChangeAvailability,
    ChangeConfiguration,
    ClearCache,
    ClearChargingProfile,
    CustomOcppLogMessage,
    DataTransfer,
    DiagnosticsStatusNotification,
    FirmwareStatusNotification,
    GetConfiguration,
    GetDiagnostics,
    Heartbeat,
    MeterValues,
    RemoteStartTransaction,
    RemoteStopTransaction,
    Reset,
    SetChargingProfile,
    StartTransaction,
    StopTransaction,
    StatusNotification,
    TriggerMessage,
    Unknown,
    UnlockConnector,
    UpdateFirmware,
}

export const LOG_TYPES_SUPPORT: Array<LogTypes> = [
    LogTypes.Authorize,
    LogTypes.BootNotification,
    LogTypes.ChangeAvailability,
    LogTypes.ChangeConfiguration,
    LogTypes.ClearCache,
    LogTypes.ClearChargingProfile,
    LogTypes.CustomOcppLogMessage,
    LogTypes.DataTransfer,
    LogTypes.DiagnosticsStatusNotification,
    LogTypes.FirmwareStatusNotification,
    LogTypes.GetConfiguration,
    LogTypes.GetDiagnostics,
    LogTypes.Heartbeat,
    LogTypes.MeterValues,
    LogTypes.Reset,
    LogTypes.RemoteStartTransaction,
    LogTypes.RemoteStopTransaction,
    LogTypes.SetChargingProfile,
    LogTypes.StartTransaction,
    LogTypes.StopTransaction,
    LogTypes.StatusNotification,
    LogTypes.TriggerMessage,
    LogTypes.Unknown,
    LogTypes.UnlockConnector,
    LogTypes.UpdateFirmware,
]

export const LOG_TYPES_PARTNER: Array<LogTypes> = [
    LogTypes.Authorize,
    LogTypes.BootNotification,
    LogTypes.ChangeConfiguration,
    LogTypes.DataTransfer,
    LogTypes.FirmwareStatusNotification,
    LogTypes.Reset,
    LogTypes.StatusNotification,
    LogTypes.StopTransaction,
]

// OCPP logs can be requested for at most this many days back
export const OCPP_LOGS_MAX_AGE_DAYS = 30
